const steps = [
  "Click or search where to put the mark.",
  " Add some details.",
  "Submit. ",
];

const lastSentance = "Thats it. We are posted, thanks to you 😉";

export { steps, lastSentance };
